/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RegenerateKeyResponse {
    getFixupPrototypeFunction() { return RegenerateKeyResponse.fixupPrototype; }

    static newInstance(model: Partial<RegenerateKeyResponse>): RegenerateKeyResponse {
        let obj = Object.assign(new RegenerateKeyResponse(), model);
        RegenerateKeyResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RegenerateKeyResponse>): RegenerateKeyResponse {
        if (!model) return null;
        return RegenerateKeyResponse.newInstance(<RegenerateKeyResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RegenerateKeyResponse) {
        if (!obj) return;

        models.RegenerateKeyResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RegenerateKeyResponse): boolean {
        Object.setPrototypeOf(obj, RegenerateKeyResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the user
     */
    user_id: string;

    /**
     * The newly generated access key
     */
    access_key: string;

    /**
     * Current status of the user
     */
    status: string;

}
